<template>
  <div id="training-container">
    <div v-bind:class="{'guide-off': !guideOn}">
      <div id="content-main">
        <a href="javascript:void(0)" v-on:click="prevPage" v-bind:disabled="isFirstPage" v-bind:class="{prev: true, disabled: isFirstPage}"></a>
        <div id="training-slides" ref="slides"></div>
        <a href="javascript:void(0)" v-on:click="nextPage" v-bind:disabled="isLastPage" v-bind:class="{next: true, disabled: isLastPage}"></a>
      </div>
      <div id="content-control" v-show="numberOfPages > 1">
        <div class="progress">
          <!-- calc((現在ページ/総ページ)*100%) -->
          <div class="bar" v-bind:style="progress"></div>
          <a v-for="step in config.steps" v-bind:key="step.page" v-on:click="setPage(step.page)" href="javascript:void(0);" class="p" v-bind:style="{left: `calc((${step.page} / ${numberOfPages}) * 100%)`}"><span>{{step.title}}</span></a>
        </div>
        <div class="controls">
          <div class="left">
            <div class="switch">
              <input type="checkbox" id="guide-switch" v-model="guideOn">
              <label for="guide-switch">ガイド</label>
            </div>
          </div>
          <div class="pager">
            <a href="javascript:void(0)" v-on:click="prevPage" v-bind:disabled="isFirstPage" v-bind:class="{prev: true, disabled: isFirstPage}"></a>
            <div class="page">
              <span class="current">{{ currentPage }}</span>
              /
              <span class="total">{{ numberOfPages }}</span>
            </div>
            <a href="javascript:void(0)" v-on:click="nextPage" v-bind:disabled="isLastPage" v-bind:class="{next: true, disabled: isLastPage}"></a>
          </div>
          <div class="right">
            <a href="javascript:void(0)" class="expander" id="screen-switcher" v-on:click="toggleFullscreen"></a>
          </div>
        </div>
      </div>
      <div id="content-side" v-bind:class="{open: tocOpened }" v-show="config.toc.length > 0">
        <a href="javascript:void(0)" class="opener" id="side-open" aria-label="目次を開く" v-on:click="toggleToc"></a>
        <div class="side-header">
          <a href="javascript:void(0)" class="closer" id="side-close" aria-label="目次を閉じる" v-on:click="closeToc"></a>
        </div>
        <div class="content">
          <ul class="subjects">
            <li v-for="toc1 in config.toc" v-bind:key="toc1.page">
              <a href="javascript:void(0)" v-on:click="setPage(toc1.page)">{{ toc1.title }}</a>
              <ul v-if="toc1.children && toc1.children.length > 0">
                <li v-for="toc2 in toc1.children" v-bind:key="toc2.page">
                  <a href="javascript:void(0)" v-on:click="setPage(toc2.page)">{{ toc2.title }}</a>
                  <ul v-if="toc2.children && toc2.children.length > 0">
                    <li v-for="toc3 in toc2.children" v-bind:key="toc3.page">
                      <a href="javascript:void(0)" v-on:click="setPage(toc3.page)">{{ toc3.title }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { createApp } from 'vue/dist/vue.esm-bundler'
  import VueTypes from 'vue-types'
  import TrainingSlide from '../components/training-slide'
  import QuestionsForm from '../components/questions-form'
  import QuestionsFormError from '../components/questions-form-error';
  import PDFViewer from '../components/pdf-viewer'

  export default {
    name: 'TrainingViewer',
    components: {
      'training-slide': TrainingSlide,
    },
    props: {
      // 表示開始ページ
      startPage: VueTypes.number.def(1),

      // スライド
      slides: VueTypes.arrayOf(
        VueTypes.shape({
          page: VueTypes.number,
          html: VueTypes.string
        })
      ),

      config: VueTypes.shape({
        toc: VueTypes.arrayOf(
          VueTypes.shape({
            page: VueTypes.number,
            title: VueTypes.string,
            children: VueTypes.arrayOf(
              VueTypes.shape({
                page: VueTypes.number,
                title: VueTypes.string,
                children: VueTypes.arrayOf(
                  VueTypes.shape({
                    page: VueTypes.number,
                    title: VueTypes.string
                  })
                )
              })
            )
          })
        ),
        steps: VueTypes.arrayOf(
          VueTypes.shape({
            page: VueTypes.number,
            title: VueTypes.string
          })
        ),
        immediate: VueTypes.arrayOf(VueTypes.number)
      })
    },
    data () {
      return {
        // スライド
        slideComponents: [],
        // ガイド
        guideOn: true,
        // 現在ページ
        currentPage: 1,
        // 目次が開いているかどうか
        tocOpened: false,
        // SP かどうか
        isSP: false,
        // fullscreen かどうか
        fullscreenOn: false,
      }
    },
    computed: {
      numberOfPages () {
        return this.slides.length
      },
      progress () {
        return {
          width: `calc((${this.currentPage} / ${this.numberOfPages}) * 100%)`
        }
      },
      isFirstPage () {
        return this.currentPage === 1
      },
      isLastPage () {
        return this.currentPage === this.numberOfPages
      }
    },
    mounted () {
      this.$nextTick(() => {
        // fullscreen 時にヘッダーが隠れる問題の対応
        setTimeout(() => this.restoreCurrentPage(), 0)
      })

      this.setupSlides()
      window.addEventListener("keydown", this.onKeydown);

      $(document)
        .on('click', '#guide-switch', (e) => {
          if ($(e.target).prop('checked')) {
            $('.text-guide, .img-guide').removeClass('open')
          }
        })
        .on('click', '.text-guide, .img-guide', (e) => {
          $('.text-guide.open, .img-guide.open').each((i, elem) => {
            if (elem !== e.currentTarget) {
              $(elem).removeClass('open')
            }
          })
          $(e.currentTarget).toggleClass('open')
        })
    },
    methods: {
      setupSlides () {
        this.slides.forEach((slide) => {
          const ComponentClass = createApp({
            extends: TrainingSlide,
          },
          {
            initshow: this.currentPage === slide.page,
            immediage: _.indexOf(this.config.immediate, slide.page) !== -1,
            page: slide.page,
            html: slide.html
          })
          ComponentClass.component('questions-form', QuestionsForm)
          ComponentClass.component('questions-form-error', QuestionsFormError)
          ComponentClass.component('pdf-viewer', PDFViewer)
          const slides = document.getElementById('training-slides')
          const chiidNode = slides.appendChild(document.createElement("dev"))
          const inst = ComponentClass.mount(chiidNode)
          this.slideComponents.push(inst)
        })



      },

      prevPage () {
        this.setPage(this.currentPage - 1)
      },

      nextPage () {
        this.setPage(this.currentPage + 1)
      },

      setPage (page) {
        this.slideComponents[this.currentPage - 1].show = false
        this.currentPage = page

        if (this.currentPage < 1) {
          this.currentPage = 1
        }
        if (this.numberOfPages < this.currentPage) {
          this.currentPage = this.numberOfPages
        }
        this.slideComponents[this.currentPage - 1].show = true
        this.saveCurrentPage()

        this.closeToc()

        if ( this.isSP ) {
          scrollTo(window.pageXOffset, 0)
        }
      },

      openToc () {
        this.tocOpened = true
      },

      closeToc () {
        this.tocOpened = false
      },

      toggleToc () {
        this.tocOpened = !this.tocOpened
      },

      toggleFullscreen() {
        const $body = $('body')
        $body.toggleClass('fullscreen')
        this.fullscreenOn = $body.hasClass('fullscreen')
      },

      setFullscreenMode(on) {
        const $body = $('body')
        if (on) {
          $body.addClass('fullscreen')
        } else {
          $body.removeClass('fullscreen')
        }
        this.fullscreenOn = $body.hasClass('fullscreen')
      },

      onKeydown (event) {
        if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
          return
        }
        if (event.key === 'ArrowLeft') {
          this.setPage(this.currentPage - 1)
        }
        if (event.key === 'ArrowRight') {
          this.setPage(this.currentPage + 1)
        }
        if (event.key === 'Escape') {
          this.setFullscreenMode(false)
        }
      },

      saveCurrentPage () {
        window.location.hash = `/pages/${this.currentPage}`
      },

      restoreCurrentPage () {
        const match = window.location.hash.match(/^#\/pages\/(\d+)/)
        if (match) {
          this.setPage(parseInt(match[1], 10))
        } else {
          this.setPage(this.startPage)
        }

        // guide, fullscreen
        this.guideOn = !Cookies.get('training_guide_off')
        this.setFullscreenMode(!!Cookies.get('fullscreen_on'))
      }
    },
    watch: {
      guideOn (val) {
        val ? Cookies.remove('training_guide_off') : Cookies.set('training_guide_off', 1)
      },
      fullscreenOn (val) {
        val ? Cookies.set('fullscreen_on', 1) : Cookies.remove('fullscreen_on')
      }
    }
  }
</script>

